import BoardPack from '@/components/BoardPack/BoardPack'

const BoardPackPageMobile = () => {
  return (
    <div className='px-3 pt-3'>
      <BoardPack />
    </div>
  )
}

export default BoardPackPageMobile;